import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      
      if (res.ok) {
        toast.success(data.message);
        setEmail('');
      } else {
        toast.error(data.detail || 'Failed to subscribe');
      }
    } catch (error) {
      toast.error('Failed to subscribe');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-black text-white py-16 md:py-24 border-t border-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="font-serif text-2xl mb-4">The Signal</h3>
            <p className="text-[#999999] leading-relaxed max-w-md mb-6">
              A structured system to improve your appearance, skin, grooming, and presence. 
              Results-focused guidance for men who want to look and feel their best.
            </p>
            
            {/* Newsletter Signup */}
            <div className="mt-6">
              <p className="text-sm uppercase tracking-widest text-[#D4AF37] mb-3">Stay Updated</p>
              <form onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="bg-[#0f0f0f] border border-[#1a1a1a] px-4 py-2 text-sm text-white placeholder-[#666666] focus:border-[#D4AF37] focus:outline-none flex-1 max-w-[240px]"
                  data-testid="newsletter-email-input"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-[#D4AF37] text-[#1A1A1A] px-4 py-2 text-sm font-semibold uppercase tracking-wider hover:bg-[#C9A030] transition-colors disabled:opacity-50"
                  data-testid="newsletter-subscribe-btn"
                >
                  {loading ? '...' : 'Join'}
                </button>
              </form>
              <p className="text-[#666666] text-xs mt-2">Get notified about new drops & tips</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-widest text-[#D4AF37] mb-6">Navigate</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-[#999999] hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-[#999999] hover:text-white transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#999999] hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#999999] hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#999999] hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm uppercase tracking-widest text-[#D4AF37] mb-6">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:contact@thesignalcore.com" className="text-[#999999] hover:text-white transition-colors">
                  contact@thesignalcore.com
                </a>
              </li>
              <li>
                <a href="https://www.tiktok.com/@rc.vnl" target="_blank" rel="noopener noreferrer" className="text-[#999999] hover:text-white transition-colors">
                  TikTok: @rc.vnl
                </a>
              </li>
            </ul>
            <h4 className="text-sm uppercase tracking-widest text-[#D4AF37] mb-4 mt-8">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className="text-[#999999] hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-[#999999] hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-[#1a1a1a] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#666666] text-sm">
            © {new Date().getFullYear()} The Signal. All rights reserved.
          </p>
          <p className="text-[#666666] text-sm">
            Educational content only. Results may vary.
          </p>
        </div>
      </div>
    </footer>
  );
};
